export {
  Skeleton,
  SkeletonTextLines,
  type SkeletonProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Skeleton';
